import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";
import Modal from "@/atomic/atoms/Modal";
import TicketModal from "@/atomic/organisms/TicketModal";
import Loading from "@/atomic/atoms/Loading";
import useI18n from "@/hooks/useI18n";
import PlanSelection from "@/atomic/organisms/PlanSelection";
import { useThemeContext } from "@/contexts/ThemeContext";

export default function CheckoutFinishedView({
  goBack,
  invoice,
  toggleModal,
  generatePDF,
  isVisibleModal,
  isLoading,
  openInvoice,
  error,
  toggleError,
  toggleModalRegister,
  handleTryAgain,
}: PropsView) {
  const { t } = useI18n();
  const { themeName, theme } = useThemeContext();
  const isZapay = themeName === "zapay";
  const title = themeName === "zapay" ? "Pedágio" : "Pagamento";

  return (
    <div className="h-full">
      <Header title={title} hasLeftButton goBack={goBack} />

      <main className="flex flex-col h-[calc(100vh-72px)] overflow-y-auto bg-white">
        <article className="flex flex-col w-full items-center flex-1">
          <div
            className={`flex flex-col w-full max-w-[1400px] mx-auto flex-1 px-5 ${isZapay ? "justify-center" : "justify-start"}`}
          >
            {isZapay ? (
              <>
                <div className="flex items-center justify-center w-full flex-col flex-shrink-0">
                  <div style={{ marginBottom: theme.spacing.large }}>
                    <img
                      src="/svg/payment-success-ilustration.svg"
                      alt={t("pages:success:paymentCompletedTitle")}
                      className="w-20 h-20 md:w-24 md:h-24"
                    />
                  </div>
                  <h2
                    className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight"
                    style={{
                      color: theme.colors.text,
                      fontFamily: theme.fonts.primary,
                    }}
                  >
                    {t("pages:success:paymentCompletedTitle")}
                  </h2>
                  <h3
                    className="text-sm md:text-base text-center px-2 max-w-md"
                    style={{
                      color: theme.colors.textSecondary,
                      fontFamily: theme.fonts.primary,
                    }}
                  >
                    {t("pages:success:paymentCompletedSupport")}
                  </h3>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-center w-full flex-col gap-[14px] mt-16 md:mt-20">
                  <div className="w-20 h-20 bg-[#e5f9f2] rounded-full flex items-center justify-center p-5 shrink-0">
                    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 13l4 4L19 7"
                        stroke="#10b981"
                        strokeWidth={2.5}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col items-center justify-center w-full max-w-[328px]">
                    <h2
                      className="text-[30px] font-extrabold text-[#0e0d0d] text-center leading-[1.1] tracking-[-0.5px]"
                      style={{ fontFamily: theme.fonts.primary }}
                    >
                      {t("pages:success:paymentCompletedTitle")}
                    </h2>
                    <p
                      className="text-base text-center text-[#525252] leading-[1.35] mt-1"
                      style={{ fontFamily: theme.fonts.primary }}
                    >
                      {t("pages:success:paymentCompletedSupport")}
                      <br />
                      <button
                        type="button"
                        onClick={openInvoice}
                        className="underline text-[#525252] hover:opacity-80"
                        style={{ fontFamily: theme.fonts.primary }}
                      >
                        {t("pages:success:openReceipt")}
                      </button>
                    </p>
                  </div>
                </div>

                <div className="w-full mt-10 md:mt-12">
                  <PlanSelection layout="stack" />
                </div>
              </>
            )}
          </div>

          {isZapay ? (
            <div className="w-full max-w-full md:w-[480px] mx-auto flex-shrink-0 pb-8">
              <div className="flex items-center flex-col px-2">
                <button
                  onClick={goBack}
                  type="button"
                  className="w-full h-[60px] text-white font-medium mb-4"
                  style={{
                    backgroundColor: theme.colors.primary,
                    borderRadius: theme.borderRadius.medium,
                    fontFamily: theme.fonts.primary,
                  }}
                >
                  {t("pages:success:goToHome")}
                </button>
                <button
                  onClick={openInvoice}
                  type="button"
                  className="w-full font-medium bg-transparent"
                  style={{
                    color: theme.colors.primary,
                    fontFamily: theme.fonts.primary,
                  }}
                >
                  {t("pages:success:openReceipt")}
                </button>
              </div>
            </div>
          ) : (
            <div className="w-full max-w-full md:w-[480px] mx-auto flex-shrink-0 py-[10px] px-5">
              <div className="flex items-center flex-col">
                <button
                  onClick={goBack}
                  type="button"
                  className="w-full h-[60px] text-white font-medium mb-4 text-base tracking-[-0.4px]"
                  style={{
                    backgroundColor: theme.colors.primary,
                    borderRadius: theme.borderRadius.large,
                    fontFamily: theme.fonts.secondary,
                  }}
                >
                  {t("pages:success:goToHome")}
                </button>
              </div>
            </div>
          )}
        </article>
      </main>
      {isLoading && <Loading />}
      {isVisibleModal && invoice && (
        <TicketModal
          invoice={invoice}
          generatePDF={generatePDF || (() => {})}
          toggleModal={toggleModal || (() => {})}
          toggleModalRegister={toggleModalRegister || (() => {})}
        />
      )}
      {error && (
        <Modal
          title="Ops"
          message={t("pages:receipt:description")}
          actionMessage={t("pages:receipt:checkAgain")}
          action={handleTryAgain}
          actionSecond={toggleError}
          actionSecondMessage={t("common:close")}
          actionClassName="w-full py-4 text-white text-base mb-4 font-bold tracking-[-0.1px]"
          actionSecondClassName="mb-2 font-bold text-base tracking-[-0.1px]"
          actionStyle={{
            backgroundColor: theme.colors.primary,
            borderRadius: isZapay ? theme.borderRadius.medium : "12px",
            fontFamily: theme.fonts.primary,
          }}
          actionSecondStyle={{
            color: theme.colors.text,
            fontFamily: theme.fonts.primary,
          }}
        />
      )}
    </div>
  );
}
